import { Epic, ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { getType } from 'typesafe-actions';

import { EpicDeps } from '../../service/StoreFactory';
import { State } from '../../typings/state';
import { CanvasEditorAction, changeCreativeType } from '../common/actions';
import { CreativeType, Page } from '../common/typings';

import { changePage, ChangePageAction } from './actions';

export const changePageEpic: Epic<CanvasEditorAction, CanvasEditorAction, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(getType(changePage)),
        switchMap((action: ChangePageAction) => {
            const type = store$.value.canvasEditor.sharedData.creativeType;

            // при переходе на страницы креативов, идей, пресетов надо обратно изменять тип креатива
            if (action.page !== Page.CONSTRUCTOR && type === CreativeType.ADAPTIVE) {
                return of(changeCreativeType(CreativeType.COMMON));
            }

            return EMPTY;
        })
    );
};
